import React from "react";
import {generateConfigData, generateInfoCard} from "Common/utility/infoCard";


export default class Support extends React.Component {


  generateItem(config, location) {
    const data = generateConfigData(config);
    const elements = generateInfoCard(data, location);

    return (
      <div className="pubhub-support-item row">
        <div className="col-md-3 pubhub-support-item-img col-sm-12 col-12 ">
          <span data-track-name="support:image"
                data-track-value={data.title} >
            {elements.image}
          </span>
        </div>
        <div className="col-md-9 col-sm-12">
          {elements.subtitle}
          <span data-track-name="support:title"
                data-track-value={data.title} >
          {elements.title}
           </span>
          {elements.description}
        </div>
      </div>
    )
  }

  render() {
    const {config, location, type} = this.props;

    if (!config) {
      return <span className="pubhub-loading"></span>
    }

    const title = config.querySelector("title").innerText.trim();
    const content = Array.from(config.querySelectorAll("item")).map((item, index) => {
      return <div className="col-md-6 col-sm-12" key={index}>{this.generateItem(item, location)}</div>
    });

    return (
      <div className="pubhub-support pubhub-widget">
        <div className="container">
          <div className="pubhub-support-title row">
            <div className="col">
              <h1>
                {title}
              </h1>
            </div>
          </div>
          <div className="pubhub-support-content row">
            {content}
          </div>
        </div>
      </div>
    )
  }
}
